import { render, staticRenderFns } from "./InsuranceProgramPage.vue?vue&type=template&id=a38485d0&scoped=true"
import script from "./InsuranceProgramPage.vue?vue&type=script&lang=js"
export * from "./InsuranceProgramPage.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProgramPage.vue?vue&type=style&index=0&id=a38485d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38485d0",
  null
  
)

export default component.exports